export default "__VITE_ASSET__bfY4V0st__"